export default __webpack_public_path__ + "static/poster-4c4d22b1463fd81a9689c470cd62e388.png";